import StrategiesCard from '../../api/strategies_card';
const FileDownload = require("js-file-download");
const strategiesCard = new StrategiesCard();

function exportFileName() {
    const date = new Date().toISOString().slice(0, 10);
    return `strategies_cards_${date}.xlsx`;
}

function parseBlobJson(blob) {
    if (!blob || typeof blob.text !== 'function') {
        return Promise.resolve(null);
    }

    return blob.text().then((text) => {
        if (!text) {
            return null;
        }
        try {
            return JSON.parse(text);
        } catch (e) {
            return null;
        }
    });
}

function isLikelyJsonBlob(blob) {
    if (!blob || typeof blob !== 'object') {
        return false;
    }
    const type = (blob.type || '').toLowerCase();
    return type.includes('json') || type.includes('text/plain') || type.includes('text/html');
}

const strategiesCardModule = {
    namespaced: true,
    state: {
        loading: false,
        strategiesCards: [],
        strategiesCard: null,
        totalStrategiesCards: 0,
    },
    getters: {
        strategiesCards: (state) => state.strategiesCards,
        strategiesCard: (state) => state.strategiesCard,
        totalStrategiesCards: (state) => state.totalStrategiesCards,
        loading: (state) => state.loading,
    },
    mutations: {
        SET_LOADING: (state, loading) => {
            state.loading = loading;
        },
        SET_STRATEGIES_CARDS: (state, data) => {
            state.strategiesCards = data;
        },
        SET_STRATEGIES_CARD: (state, data) => {
            state.strategiesCard = data;
        },
        SET_TOTAL_STRATEGIES_CARDS: (state, count) => {
            state.totalStrategiesCards = count;
        },
    },
    actions: {
        GetStrategiesCards({ commit }, payload) {
            const query = (payload && payload.query) || {};
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                strategiesCard.list(query).then(response => {
                    if (response) {
                        const data = Array.isArray(response) ? response : (response.strategiesCards || response.strategies_cards || response.data || []);
                        commit('SET_STRATEGIES_CARDS', data);
                        commit('SET_TOTAL_STRATEGIES_CARDS', response.total || response.count || data.length || 0);
                    }
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        ShowStrategiesCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                strategiesCard.show(id).then(response => {
                    if (response) {
                        commit('SET_STRATEGIES_CARD', response.strategiesCard || response.strategies_card || response.data || response);
                    }
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        CreateStrategiesCard({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                strategiesCard.store(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        UpdateStrategiesCard({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                strategiesCard.update(payload.id, payload.form).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        DeleteStrategiesCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                strategiesCard.delete(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        RestoreStrategiesCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                strategiesCard.restore(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        ImportStrategiesCards({ commit }, file) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                strategiesCard.import(file).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        ExportStrategiesCards(_, payload) {
            const filters = (payload && payload.filters) || {};
            return new Promise((resolve, reject) => {
                strategiesCard.export(filters).then(async (response) => {
                    if (response instanceof Blob && isLikelyJsonBlob(response)) {
                        const parsed = await parseBlobJson(response);
                        const error = new Error((parsed && (parsed.message || parsed.error)) || 'Export failed');
                        error.response = {
                            data: parsed || response,
                            status: (parsed && parsed.status_code) || 422
                        };
                        reject(error);
                        return;
                    }

                    if (response instanceof Blob) {
                        FileDownload(response, exportFileName());
                        resolve(response);
                        return;
                    }

                    reject(new Error('Invalid export response'));
                }).catch(async (error) => {
                    const data = error && error.response && error.response.data;
                    if (data instanceof Blob) {
                        const parsed = await parseBlobJson(data);
                        if (parsed) {
                            error.parsedBlobError = parsed;
                            error.response.data = parsed;
                        }
                    }
                    reject(error);
                });
            });
        },
    }
};

export default strategiesCardModule;
